import React, { useContext } from "react";
import { getProfileIconFromDisplayName } from "../../components/character-picker";

import LogoSmall from "../../assets/images/ad-logo-snow.svg";
import AvatarBG from "../../assets/images/avatar-bg.svg";
import "./header.scss";
import { UserContext } from "../UserContext";
import { motion } from "framer-motion";

const logoLink =
  process.env.NODE_ENV === "development"
    ? "/"
    : "https://www.tbs.com/shows/american-dad";
const Header = () => {
  const { user } = useContext(UserContext);

  return (
    <motion.nav
      initial={{ y: -200, height: 0 }}
      animate={{ y: 0, height: 75, transition: { delay: 0.3 } }}
    >
      <div className="nav-left">
        <a href={logoLink}>
          <img src={LogoSmall} alt="American Dad 300th episode" />
        </a>
      </div>
      <div className="nav-right">
        <div className="user-profile">
          <div className="user-profile-nameplate">{user.name}</div>
          <div
            className="user-profile-image"
            style={{
              backgroundImage: `url(${getProfileIconFromDisplayName(
                user.name
              )})`
            }}
          ></div>
          {/* <img className="user-profile-bg" src={AvatarBG} alt="Your Profile"/> */}
        </div>
        {/* <div
          className={classNames({
            menu: true,
            open: toggled,
          })}
          onClick={() => setToggled(!toggled)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div> */}
      </div>
    </motion.nav>
  );
};
export default Header;
